export default class HashUrl {
  constructor(fixedContent) {
    if(location.hash){
      this.hash = location.hash;
    }else{
      this.hash = '';
    }

    if(fixedContent){
      this.fixedCont = fixedContent;
      this.fixedContentHeight = this.fixedCont.clientHeight;
    }else{
      this.fixedContentHeight = 0;
    }

    this.init();
  }

  init(){
    if(this.hash.length != 0){//hashがあれば
      let anchorTarget = document.querySelector(this.hash);
      if(anchorTarget){
        window.scrollTo({
          top: anchorTarget.getBoundingClientRect().top + window.scrollY - this.fixedContentHeight,
          behavior: 'smooth',
        });
      }
    }
  }

}
